"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var classNames = require("classnames");
var ShopBadges = /** @class */ (function (_super) {
    tslib_1.__extends(ShopBadges, _super);
    function ShopBadges() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShopBadges.prototype.hasNoBadges = function () {
        return (!this.props.preferredSeller &&
            !this.props.quickShipper &&
            !this.props.quickResponder);
    };
    ShopBadges.prototype.renderPreferredSeller = function () {
        if (!this.props.preferredSeller) {
            return null;
        }
        return (React.createElement("div", { className: "shared-shop-badge shared-shop-badge--preferred-seller", "data-tooltip-text": I18n.t('commons.shopBadges.preferredSellerDescription') },
            React.createElement("span", null, I18n.t('commons.shopBadges.preferredSeller'))));
    };
    ShopBadges.prototype.renderQuickResponder = function () {
        if (!this.props.quickResponder) {
            return null;
        }
        return (React.createElement("div", { className: "shared-shop-badge shared-shop-badge--quick-responder", "data-tooltip-text": I18n.t('commons.shopBadges.quickResponderDescription') },
            React.createElement("span", null, I18n.t('commons.shopBadges.quickResponder'))));
    };
    ShopBadges.prototype.renderQuickShipper = function () {
        if (!this.props.quickShipper) {
            return null;
        }
        return (React.createElement("div", { className: "shared-shop-badge shared-shop-badge--quick-shipper", "data-tooltip-text": I18n.t('commons.shopBadges.quickShipperDescription') },
            React.createElement("span", null, I18n.t('commons.shopBadges.quickShipper'))));
    };
    ShopBadges.prototype.render = function () {
        if (!this.props || this.hasNoBadges()) {
            return null;
        }
        var classes = classNames('shared-shop-badges', { 'shared-shop-badges--with-captions': this.props.withCaptions }, { 'shared-shop-badges--small': this.props.smallBadges });
        return (React.createElement("div", { className: classes },
            this.renderPreferredSeller(),
            this.renderQuickResponder(),
            this.renderQuickShipper()));
    };
    return ShopBadges;
}(React.Component));
exports.default = ShopBadges;
//# sourceMappingURL=shop_badges.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/shop_badges.js
// module id = pcsn
// module chunks = 20 21